import { render, staticRenderFns } from "./BrazilVTooltip.vue?vue&type=template&id=7c0240d8&scoped=true&"
import script from "./BrazilVTooltip.vue?vue&type=script&lang=js&"
export * from "./BrazilVTooltip.vue?vue&type=script&lang=js&"
import style0 from "./BrazilVTooltip.vue?vue&type=style&index=0&id=7c0240d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0240d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
